module.exports = __webpack_public_path__ + "static/media/may-icon.bef30e3b.png";